/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import { useState } from 'react';
import {
  Grid,
  Box,
  Button,
  CircularProgress,
  Typography,
  Stack,
  FormControlLabel,
  Checkbox,
  Alert,
  AlertTitle,
} from '@mui/material';
import { Form, Formik, FormikState } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import { setAlert } from '@/store/slices/alert';
import { selectCart, selectDelivery, selectOrder } from '@/store/selectors';
import {
  updatePaymentMethod,
  // updateTotal,
  updateChangeGiven,
  updateChangeSaved,
  applyChange,
} from '@/store/slices/order';
import {
  useSubmitPayment,
  useFetchLoggedUser,
  useFetchPosProfileDetails,
  useDeleteDraftInvoice,
  useFetchCustomer,
  useFetchConversionFactor,
} from '@/services/hooks';
import { SaveChange, ConfirmPaymentSubmission } from '@/components/Modals';
import { ChangeObjectType } from '@/components/Modals/SaveChange';

import AmountLeft from './helpers/AmountLeft';
import Change from './helpers/Change';
import { clearDeliveryDetails } from '@/store/slices/delivery';

const inputBox = {
  height: '44px',
  width: '100%',
  display: 'flex',
  gap: '10px',
  alignItems: 'center',
  borderRadius: '8px',
  border: 'none',
  position: 'relative',

  '& input': {
    width: '226px',
    height: '44px',
    borderRadius: '8px',
    border: '1px solid #D9D9D9',
    fontFamily: 'inherit',
    px: 2,

    '&:focus': {
      outline: 'none',
    },
  },
};

let initialState: any = {};

const SubmitPaymentForm = () => {
  const [toggleRedeemPoints, setToggleRedeemPoints] = useState(false);

  const [disableLoyaltyBtn, setdisableLoyaltyBtn] = useState(false);
  const [btnError, setBtnError] = useState(false);

  const { items } = useSelector(selectCart);
  const { delivery, deliveryName, toggleDelivery } =
    useSelector(selectDelivery);

  const {
    current_invoice,
    customer,
    customer_balance: customerBalance,
    taxes,
    discount,
    change,
    sub_total: subTotal,
    total: totalCost,
    apply_change,
  } = useSelector(selectOrder);

  const total = totalCost + (delivery?.delivery_amount || 0);
  const usedChange = customerBalance < totalCost ? customerBalance : totalCost;
  const changeRemaining =
    customerBalance > totalCost ? customerBalance - totalCost : 0;

  const dispatch = useDispatch();
  const { data: loggedUser } = useFetchLoggedUser();
  const { data: customerDetails } = useFetchCustomer(customer);
  const { data: conversionFactor } = useFetchConversionFactor(
    customerDetails?.loyalty_program,
  );
  const { data: profile } = useFetchPosProfileDetails();
  const { mutate: submitInvoice, isLoading } = useSubmitPayment();
  const { mutate: deleteInvoice, isLoading: isDeleting } =
    useDeleteDraftInvoice();
  const [showSaveChange, setShowSaveChange] = useState(false);
  const [useChange, setUseChange] = useState(false);
  const [showChangeNotice, setShowChangeNotice] = useState(customerBalance > 0);
  const [formValues, setFormValues] =
    useState<typeof initialState>(initialState);

  const [confirmPaymentSubmission, setConfirmPaymentSubmission] =
    useState(false);

  const [partialPayment, setPartialPayment] = useState(false);

  const paymentState = profile?.payments.reduce((total: any, current: any) => {
    total[current.mode_of_payment] = 0;
    return total;
  }, {});

  const deliveryDetails = toggleDelivery
    ? {
        ...delivery,
        driver: 'Desktop driver',
        vehicle: 'Desktop vehicle',
        estimated_departure_time: new Date(),
        estimated_delivery_time: new Date(),
        company: profile?.company,
      }
    : null;

  initialState = {
    ...paymentState,
    loyalty_points: 0,
    loyalty_amount: 0,
  };

  const handleSplit = (values: typeof initialState) => {
    const updatedPaymentAmount = profile?.payments.map((curr: any) => {
      const paymentsObject = {
        ...curr,
        amount: values[curr.mode_of_payment] - (delivery?.delivery_amount || 0),
      };

      return paymentsObject;
    });

    // Filter out payments options that amounts to zero
    const paymentItems = updatedPaymentAmount.filter(
      (item: any) => item.amount > 0 && item.amount !== '',
    );

    // Create the payment object
    const paymentObj = {
      name: current_invoice,
      owner: loggedUser,
      customer,
      discount_amount: discount,
      redeem_loyalty_points: toggleRedeemPoints ? 1 : 0,
      loyalty_amount: values.loyalty_amount,
      loyalty_points: values.loyalty_points,
      change_amount: change,
      loyalty_account: 'Cash',
      items,
      delivery: {
        ...(deliveryDetails?.name ? {} : { name: deliveryName }),
        ...deliveryDetails,
      },
      company: profile?.company,
      payments: paymentItems,
      custom_wallet: 1,
    };

    return paymentObj;
  };

  const handlePaymentObject = () => {
    const paymentObj = handleSplit(formValues);
    // eslint-disable-next-line arrow-body-style
    const totalAmount = paymentObj.payments.reduce((total: any, curr: any) => {
      return total + curr.amount;
    }, 0);
    const amountIsComplete = totalAmount === total;
    if (!amountIsComplete && !profile?.posa_allow_partial_payment) {
      dispatch(
        setAlert({
          type: 'error',
          message: 'Amount not completed yet!',
        }),
      );
    } else {
      return paymentObj;
    }

    return paymentObj;
  };

  const handleUpdatePaymentMethod = (payments: Array<Record<string, any>>) => {
    const paymentMethods = payments.map((payment) => ({
      type: payment.mode_of_payment,
      amount: payment.amount,
    }));

    dispatch(updatePaymentMethod(paymentMethods));
  };

  const handleConfirmationSubmission = () => {
    setConfirmPaymentSubmission(false);
    if (change > 0) {
      setShowSaveChange(true);
    } else {
      const payments = handleSplit(formValues);
      handleUpdatePaymentMethod(payments.payments);
      const data = {
        use_change: useChange ? 1 : 0,
        save_change: 0,
        saved_change: 0,
        change_collected: 0,
        payments,
      };
      submitInvoice(data);
    }
  };

  const handleSubmit = (values: typeof initialState) => {
    setFormValues(values);
    const payments = handleSplit(values);
    const totalAmount = payments.payments.reduce((total: any, curr: any) => {
      return total + curr.amount;
    }, 0);
    const amountIsComplete = totalAmount >= total;

    if (!amountIsComplete && !profile?.posa_allow_partial_payment) {
      dispatch(
        setAlert({
          type: 'error',
          message: 'Amount not completed yet!',
        }),
      );

      return;
    }

    if (amountIsComplete) {
      setPartialPayment(false);
    } else {
      setPartialPayment(true);
    }

    setConfirmPaymentSubmission(true);
  };

  const handleSaveChangeAction = (changeObject: ChangeObjectType) => {
    const payments = handlePaymentObject();
    handleUpdatePaymentMethod(payments.payments);

    dispatch(updateChangeSaved(changeObject.amountSaved));
    dispatch(updateChangeGiven(changeObject.amountGiven));

    const data = {
      use_change: useChange ? 1 : 0,
      save_change: changeObject.answer === 'yes' ? 1 : 0,
      saved_change: changeObject.amountSaved,
      change_collected: changeObject.amountGiven,
      payments,
    };

    submitInvoice(data);

    setShowSaveChange(false);
  };

  const handleDeleteDraftInvoice = () => {
    deleteInvoice();
    setTimeout(() => {
      dispatch(clearDeliveryDetails());
    }, 4000);
  };

  const handleAutoFill = (
    name: string,
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean | undefined,
    ) => void,
    resetForm: (nextState?: Partial<FormikState<any>> | undefined) => void,
  ) => {
    resetForm();
    const paymentAmount = apply_change ? total - customerBalance : total;
    setFieldValue(name, customerBalance > total ? 0 : paymentAmount, true);
  };

  const handleAutoFillRedeemPoints = (
    name: string,
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean | undefined,
    ) => void,
  ) => {
    setFieldValue(name, customerDetails?.loyalty_points);

    let loyaltyPointAmount = 0;

    if (conversionFactor && customerDetails) {
      loyaltyPointAmount =
        customerDetails.loyalty_points * conversionFactor.conversion_factor;
    }

    setFieldValue('loyalty_amount', loyaltyPointAmount);
  };

  const handleLoyaltyPointsCalculation = (
    value: number,
    field: string,
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean | undefined,
    ) => void,
  ) => {
    if (value > customerDetails?.loyalty_points) {
      setdisableLoyaltyBtn(true);
      setBtnError(true);
      setFieldValue('loyalty_points', 0);
      setFieldValue(field, 0);

      return;
    }
    let loyaltyPointAmount = 0;

    if (conversionFactor) {
      loyaltyPointAmount = value * conversionFactor.conversion_factor;
    }
    setdisableLoyaltyBtn(false);
    setBtnError(false);
    setFieldValue(field, loyaltyPointAmount);
  };

  const handleToggleRedeemPoints = (
    event: React.ChangeEvent<HTMLInputElement>,
    resetForm: (nextState?: Partial<FormikState<any>> | undefined) => void,
  ) => {
    setToggleRedeemPoints(event.target.checked);

    if (!event.target.checked) {
      resetForm();
    }
  };

  const handleUseChange = () => {
    setUseChange(true);

    // const newTotal = total - customerBalance;

    // dispatch(updateTotal(newTotal));
    dispatch(applyChange(true));

    setShowChangeNotice(false);
  };

  const handleCloseChangeModal = () => {
    setShowSaveChange(false);
  };

  const handleCloseConfirmationModal = () => {
    setConfirmPaymentSubmission(false);
  };

  return (
    <>
      <SaveChange
        show={showSaveChange}
        handleModalClose={handleCloseChangeModal}
        handleSaveChangeAction={handleSaveChangeAction}
      />
      <ConfirmPaymentSubmission
        show={confirmPaymentSubmission}
        handleModalClose={handleCloseConfirmationModal}
        handleConfirm={handleConfirmationSubmission}
        partialPayment={partialPayment}
      />
      <Box mt={6}>
        <Formik
          enableReinitialize
          initialValues={initialState}
          onSubmit={handleSubmit}
        >
          {(props) => (
            <Form onSubmit={props.handleSubmit}>
              <Stack
                sx={{ width: '100%', textAlign: 'left' }}
                spacing={2}
                mt={-3}
                mb={1}
              >
                {showChangeNotice && (
                  <Alert
                    severity="info"
                    variant="filled"
                    sx={{
                      background: '#242C32',
                      padding: 2,
                      borderRadius: 2,
                    }}
                    action={
                      <Button
                        type="button"
                        variant="contained"
                        disableElevation
                        onClick={handleUseChange}
                        sx={{
                          borderRadius: 2,
                          height: '44px',
                          backgroundColor: '#fff',
                          color: '#252525',
                          '&:hover': {
                            color: '#fff',
                          },
                        }}
                      >
                        Apply Change
                      </Button>
                    }
                  >
                    <AlertTitle
                      sx={{
                        fontWeight: '600',
                        fontFamily: 'Montserrat',
                      }}
                    >
                      Use Change
                    </AlertTitle>
                    <Typography>
                      You are owing this customer
                      <Typography
                        fontWeight={600}
                        sx={{ display: 'inline-block', ml: '5px' }}
                      >
                        {profile?.currency}
                        {customerBalance.toLocaleString('en-US')}
                      </Typography>
                    </Typography>
                  </Alert>
                )}
              </Stack>
              <Grid container columnSpacing={4} rowSpacing={4}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      border: '1px solid #D9D9D9',
                      borderRadius: '20px',
                      backgroundColor: '#fff',
                      width: '100%',
                      maxHeight: '200px',
                      height: '200px',
                      overflow: 'auto',
                      padding: '32px 45px',
                    }}
                  >
                    <Stack
                      direction="row"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mx: 'auto',
                        mb: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          color: (theme) => theme.palette.primary.main,
                          fontWeight: '600',
                          fontFamily: 'Montserrat',
                        }}
                      >
                        Subtotal
                      </Typography>
                      <Typography
                        sx={{
                          color: (theme) => theme.palette.primary.main,
                          fontWeight: '600',
                          fontFamily: 'Montserrat',
                        }}
                      >
                        {profile?.currency}
                        {subTotal.toLocaleString('en-US')}
                      </Typography>
                    </Stack>
                    {taxes.map((tax) => (
                      <Stack
                        key={tax.account_head}
                        direction="row"
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          mx: 'auto',
                          mb: 1,
                        }}
                      >
                        <Typography fontFamily="Montserrat">
                          {tax.description}
                        </Typography>
                        <Typography fontFamily="Montserrat">
                          {profile?.currency}
                          {tax.tax_amount}
                        </Typography>
                      </Stack>
                    ))}

                    <Stack
                      direction="row"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mx: 'auto',
                        mb: 1,
                      }}
                    >
                      <Typography fontFamily="Montserrat">Discount</Typography>
                      <Typography fontFamily="Montserrat">
                        {profile?.currency}
                        {discount.toLocaleString()}
                      </Typography>
                    </Stack>
                    {delivery?.delivery_amount ? (
                      <Stack
                        direction="row"
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          mx: 'auto',
                          mb: 1,
                        }}
                      >
                        <Typography fontFamily="Montserrat">
                          Delivery Cost
                        </Typography>
                        <Typography fontFamily="Montserrat">
                          {profile?.currency}
                          {delivery?.delivery_amount?.toLocaleString()}
                        </Typography>
                      </Stack>
                    ) : null}
                    {useChange && (
                      <>
                        <Stack
                          direction="row"
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            mx: 'auto',
                            mb: 1,
                          }}
                        >
                          <Typography fontFamily="Montserrat">
                            Change Used
                          </Typography>
                          <Typography fontFamily="Montserrat">
                            {profile?.currency}
                            {usedChange.toLocaleString()}
                          </Typography>
                        </Stack>
                        <Stack
                          direction="row"
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            mx: 'auto',
                            mb: 1,
                          }}
                        >
                          <Typography fontFamily="Montserrat">
                            Change Left
                          </Typography>
                          <Typography fontFamily="Montserrat">
                            {profile?.currency}
                            {changeRemaining.toLocaleString()}
                          </Typography>
                        </Stack>
                      </>
                    )}
                    <Stack
                      direction="row"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mx: 'auto',
                        mb: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          color: (theme) => theme.palette.primary.main,
                          fontWeight: '600',
                          fontFamily: 'Montserrat',
                        }}
                      >
                        Total
                      </Typography>
                      <Typography
                        sx={{
                          color: (theme) => theme.palette.primary.main,
                          fontWeight: '600',
                          fontFamily: 'Montserrat',
                        }}
                      >
                        {profile?.currency}
                        {total.toLocaleString('en-US')}
                      </Typography>
                    </Stack>
                  </Box>
                </Grid>

                <Grid item xs={12} sx={{ width: '100%' }}>
                  <Stack
                    direction="row"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={toggleRedeemPoints}
                            onChange={(e) =>
                              handleToggleRedeemPoints(e, props.resetForm)
                            }
                            inputProps={{ 'aria-label': 'controlled' }}
                          />
                        }
                        label="Apply Loyalty Points"
                      />
                    </Box>
                  </Stack>
                </Grid>

                <Grid item xs={8} sx={{ mx: 'auto' }}>
                  <AmountLeft />
                  <Change />
                </Grid>

                {/* PAYMENT METHODS */}
                <Grid item xs={8} sx={{ mx: 'auto', position: 'relative' }}>
                  <Box>
                    {profile?.payments.map((payment: any) => (
                      <Box sx={inputBox} key={payment.name} mb="20px">
                        <input
                          name={payment.mode_of_payment}
                          type="number"
                          value={props.values[payment.mode_of_payment]}
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue === '') {
                              e.target.value = '0';
                              props.handleChange(e);
                              return;
                            }
                            const value = parseFloat(inputValue);

                            if (value <= 0) {
                              e.target.value = '';
                              return;
                            }

                            e.target.value = value.toString();

                            props.handleChange(e);
                          }}
                        />
                        <Button
                          type="button"
                          variant="contained"
                          disableElevation
                          onClick={() => {
                            handleAutoFill(
                              payment.mode_of_payment,
                              props.setFieldValue,
                              props.resetForm,
                            );
                          }}
                          sx={{
                            borderRadius: 2,
                            width: '154px',
                            height: '44px',
                          }}
                        >
                          {payment.mode_of_payment}
                        </Button>
                      </Box>
                    ))}

                    {toggleRedeemPoints && (
                      <Box sx={inputBox} mb="20px">
                        <input
                          name="loyalty_points"
                          type="number"
                          value={props.values.loyalty_points}
                          onChange={(e) => {
                            props.handleChange(e);
                            handleLoyaltyPointsCalculation(
                              +e.target.value,
                              'loyalty_amount',
                              props.setFieldValue,
                            );
                          }}
                        />
                        <Button
                          type="button"
                          variant="contained"
                          disableElevation
                          disabled={disableLoyaltyBtn}
                          onClick={() => {
                            handleAutoFillRedeemPoints(
                              'loyalty_points',
                              props.setFieldValue,
                            );
                          }}
                          sx={{
                            borderRadius: 2,
                            width: '154px',
                            height: '44px',
                          }}
                        >
                          Loyalty Points
                        </Button>
                        <Box
                          sx={{
                            position: 'absolute',
                            top: '10px',
                            right: '-120px',
                          }}
                        >
                          Avaliable: {customerDetails?.loyalty_points} points
                        </Box>

                        {btnError && (
                          <Box
                            sx={{
                              position: 'absolute',
                              top: '50px',
                              right: '150px',
                              color: 'red',
                            }}
                          >
                            Not enough points
                          </Box>
                        )}
                      </Box>
                    )}
                  </Box>
                </Grid>

                {/* SUBMIT BUTTON */}
                <Grid item xs={6} sx={{ mx: 'auto' }}>
                  {isDeleting ? (
                    <CircularProgress />
                  ) : (
                    <Button
                      type="button"
                      variant="contained"
                      disableElevation
                      onClick={handleDeleteDraftInvoice}
                      sx={{
                        borderRadius: 2,
                        backgroundColor: '#C53B20',
                        mb: 2,
                      }}
                    >
                      Cancel Order
                    </Button>
                  )}

                  {isLoading ? (
                    <CircularProgress />
                  ) : (
                    <Button
                      type="submit"
                      variant="contained"
                      disableElevation
                      sx={{ borderRadius: 2 }}
                    >
                      Submit Payment
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Box>
    </>
  );
};

export default SubmitPaymentForm;
